export default __webpack_public_path__ + "static/media/pineapple.4cca914d.png";